/**
 * Maps API payload to the shape expected by Refund page components.
 * @param {object} data
 * @returns {{ hero: object, sections: Array, cta: object }}
 */
export function mapPublicRefundPayload(data) {
  if (!data || typeof data !== 'object') {
    return { hero: null, sections: [], cta: null };
  }

  const hero = data.hero
    ? {
        badge: data.hero.badge ?? 'Legal',
        title: data.hero.title ?? '',
        subtitle: data.hero.subtitle ?? '',
        lastUpdated: data.hero.lastUpdated ?? data.hero.last_updated ?? '',
      }
    : null;

  const sections = Array.isArray(data.sections)
    ? data.sections.map((section, index) => ({
        id: section.id ?? section.slug ?? `section-${index}`,
        title: section.title ?? '',
        content: section.content ?? '',
        list: Array.isArray(section.list)
          ? section.list
          : Array.isArray(section.list_items)
            ? section.list_items
            : undefined,
        footer: section.footer ?? section.footer_text ?? undefined,
      }))
    : [];

  const cta = data.cta
    ? {
        heading: data.cta.heading ?? '',
        subheading: data.cta.subheading ?? '',
        primaryButton: data.cta.primaryButton ?? data.cta.primary_button ?? 'Contact Support',
        secondaryButton:
          data.cta.secondaryButton ?? data.cta.secondary_button ?? 'View Pricing Plans',
      }
    : null;

  return { hero, sections, cta };
}

export function hasRefundContent({ hero, sections, cta }) {
  return Boolean(hero?.title) || sections.length > 0 || Boolean(cta?.heading);
}
